export default __webpack_public_path__ + "neutral.hdr";